import { useTranslation } from 'react-i18next';
import useDeviceDetection from '@/hooks/useDeviceDetection';
import styles from './DeviceWarning.module.css';
import deviceNotSupportedIc from '@/assets/icons/deviceNotSupported.svg';
import Button from '@/components/ui/Button';

const OLD_WEBSITE_URL = import.meta.env.VITE_OLD_WEBSITE_URL || '/';

const DeviceWarning = () => {
  const { isTablet } = useDeviceDetection();
  const { t } = useTranslation();

  // if (isLaptop || isTablet) {
    return null;
  // }

  const messageBoxClassName = `${styles.messageBox} ${isTablet ? styles.tabletMessageBox : ''}`;

  const handleToOldWebsite = () => {
    window.location.href = OLD_WEBSITE_URL;
  };

  return (
    <div className={styles.container}>
      <div className={messageBoxClassName}>
        <div className={styles.contentWrapper}>
          <img src={deviceNotSupportedIc} alt="deviceNotSupported" className={styles.icon} />
          <h1 className="heading-h3-bold text-(--font-sub-title-2) mb-6">{t('unsupportedDeviceTitle')}</h1>
          <div className={styles.divider}></div>
          <span className={styles.message1}>{t('unsupportedDeviceMessage1')}</span>
          <br />
          <span className={styles.message2}>{t('unsupportedDeviceMessage2')}</span>
          <br />
          <Button onClick={handleToOldWebsite} variant="primary" className={styles.linkButton}>
            {t('toOldWebsite')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeviceWarning;
